import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyA-HI3nzYiSr6l1OtCNUHjGRCc7PNF1iaU",
  authDomain: "translate2l.firebaseapp.com",
  databaseURL: "https://translate2l.firebaseio.com",
  projectId: "translate2l",
  storageBucket: "translate2l.appspot.com",
  messagingSenderId: "941174168815",
  appId: "1:941174168815:web:833ff31c96914f08e84f1a",
};

var fire = firebase.initializeApp(firebaseConfig);

export default fire;
